/**
 * Returns up to two uppercase letters extracted from a string —
 * used for avatar initials (mirrors buyer's findUpper).
 */
export const findUpper = (str: string): string => {
  if (!str) return "";
  const letters: string[] = [];
  for (let i = 0; i < str.length; i++) {
    const ch = str.charAt(i);
    if (ch === ch.toUpperCase() && ch !== " " && /[A-Z]/.test(ch)) {
      letters.push(ch);
    }
  }
  if (letters.length > 1) return letters[0] + letters[1];
  if (letters.length === 1) return letters[0];
  return str.charAt(0).toUpperCase();
};
